/**
 * Fixture times in the visitor's own time zone. The server prints them in
 * UTC with the zone named ("Sun 1 Nov · 19:00 UTC"); this rewrites each
 * <time class="when"> into local time, which can move the date too. All-day
 * events keep their date: it is the same day everywhere.
 */

const dateFormat = new Intl.DateTimeFormat(undefined, { weekday: "short", day: "numeric", month: "short" });
const timeFormat = new Intl.DateTimeFormat(undefined, { hour: "2-digit", minute: "2-digit" });

/** "Sun 1 Nov" in the visitor's locale, without the comma some locales add. */
export const localDate = (at: Date): string => dateFormat.format(at).replace(/,/g, "");

export const localTime = (at: Date): string => timeFormat.format(at);

/** Rewrites one <time class="when"> for a timed event (its date too, if shown); leaves all-day dates alone. */
export function localise(time: HTMLTimeElement): void {
  const clock = time.querySelector(".when-time");
  if (!clock) return;
  const at = new Date(time.dateTime);
  if (Number.isNaN(at.getTime())) return;
  const date = time.querySelector(".when-date");
  if (date) date.textContent = localDate(at);
  clock.textContent = localTime(at);
}

/** Localises every fixture time on the page. */
export function localiseTimes(root: ParentNode = document): void {
  for (const time of root.querySelectorAll<HTMLTimeElement>("time.when")) localise(time);
}
